import React from 'react';

import DesktopDefaultConfigData from './defaultConfigConstants/defaultDesktop';
import MobileDefaultConfigData from './defaultConfigConstants/defaultMobile';
import DesktopMapConfigData from './mapbox-constants/desktop_config_constants';
import MobileMapConfigData from './mapbox-constants/mobile_config_constants';
import SeatMapWrapper from './seatMapWrapper';

const SeatMapMapbox = (props) => {
  return <SeatMapWrapper {...props} />;
};

export default SeatMapMapbox;
export {
  SeatMapWrapper,
  SeatMapMapbox,
  DesktopMapConfigData,
  MobileMapConfigData,
  DesktopDefaultConfigData,
  MobileDefaultConfigData,
};
